<template>
   <b-col>
    <b-row v-if="loadingData">
      <b-col>
        <spinner style="margin-top: 20px;"></spinner>
      </b-col>
    </b-row>
    <div v-else style="marin-top: 20px;">
     <b-row>
       <b-col sm="12">
        <b-card>
          <div slot="header">
            Status dos Servidores
          </div>
          <div v-for="server in servers" :key="server._id" :style="{color: (server.status ? 'black' : 'red')}">
            {{server.name}}: <b>{{(server.status ? "Ativo" : "Fora do Ar")}}</b>
          </div>
        </b-card>
      </b-col>
        <b-col sm="12">
          <b-card no-body>
            <b-tabs card>
              <b-row style="margin-bottom: 20px; margin-top: 10px; margin-left: 1px;">
                <b-col sm="3">
                  <b-form-select id="basicSelectLg"
                    v-model="filterRequester"
                    size="lg"
                    :plain="true"
                    :options="[{value: 0, text: 'Todos os Solicitantes'},{value: 1, text: 'Interno'}, {value: 2, text: 'Cliente'}, {value: 3, text: 'Perfil Sleeker'}, {value: 4, text: 'Receita'}]"
                    value="Please select">
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <b-form-select id="basicSelectLg"
                    v-model="filterController"
                    size="lg"
                    :plain="true"
                    :options="adminOptions"
                    value="Please select">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <b-form-select id="basicSelectLg"
                    v-model="filterType"
                    size="lg"
                    :plain="true"
                    :options="[{value: 0, text: 'Qualquer'},{value: '1', text: 'Nutri'}, {value: '2', text: 'Personal'}, {value: '3', text: 'Psico'}]"
                    value="Please select">
                  </b-form-select>
                </b-col>
                <b-col sm="4" offset-sm="0">
                  <b-row>
                    <b-col sm="4" class="text-center">
                      <b-button variant="primary" style="width: 120px; height: 35px;" @click="goToProductivity()">
                        <i class="fa fa-chart"></i> Produtividade
                      </b-button>
                    </b-col>
                    <b-col sm="4" class="text-center">
                      <b-button variant="warning" style="width: 120px; height: 35px; color:white;" @click="goToSources()">
                        <i class="fa fa-chart"></i> Fontes
                      </b-button>
                    </b-col>
                    <b-col sm="4" class="text-center">
                      <b-button style="width: 120px; height: 35px;" variant="success" @click="add()">
                        <i class="fa fa-chart"></i> Adicionar
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <br/>
              <b-row>
                <b-col sm="2" offset-sm="5">
                  <b-form-group>
                    <multiselect
                      v-model="selectedCategories"
                      class="background-multiSelect"
                      placeholder="Selecione uma categoria"
                      label="name"
                      track-by="_id"
                      :options="categoriesList"
                      :multiple="true"
                      :taggable="true"
                      :select-label="'Selecionar'"
                      :deselect-label="'Remover'"
                      :selected-label="'Selecionado'"
                      @tag="addTag"
                    ></multiselect>
                  </b-form-group>
                </b-col>
                <b-col sm="2" >
                  <b-form-input v-model="search" placeholder="Solicitante - Diferencia maiúscula e minúscula">
                  </b-form-input>
                </b-col>
                <b-col sm="2">
                  <b-form-input v-model="requestSearch" placeholder="Pedido">
                  </b-form-input>
                </b-col>
                <b-col sm="1" class="text-center">
                  <b-button variant="primary" @click="getCreations()">
                    <i class="fa fa-add"></i> Buscar
                  </b-button>
                </b-col>
                <b-col sm="12">
                <b-tab :title="'Pedidos e Sugestões (' + this.creations.starting.length + ')'">
                  <creation-list filter="1" v-bind:creations="this.creations.starting" v-bind:filterRequester="filterRequester" v-bind:filterController="filterController" :filterType="filterType"/>
                </b-tab>
                <b-tab :title="'Com conteúdo, Sem Legenda (' + this.creations.noSubtitle.length + ')'">
                  <creation-list filter="2" v-bind:creations="this.creations.noSubtitle" v-bind:filterRequester="filterRequester" v-bind:filterController="filterController" :filterType="filterType"/>
                </b-tab>
                <b-tab :title="'Revisando Legenda (' + this.creations.subtitleReview.length + ')'">
                  <creation-list filter="6" v-bind:creations="this.creations.subtitleReview" v-bind:filterRequester="filterRequester" v-bind:filterController="filterController" :filterType="filterType"/>
                </b-tab>
                <b-tab :title="'Legenda Aprovada (' + this.creations.hasSubtitle.length + ')'" active>
                  <creation-list filter="3" v-bind:creations="this.creations.hasSubtitle" v-bind:filterRequester="filterRequester" v-bind:filterController="filterController" :filterType="filterType"/>
                </b-tab>
                <b-tab :title="'Arte Criada (' + this.creations.hasArt.length + ')'">
                  <creation-list filter="4" v-bind:creations="this.creations.hasArt" v-bind:filterRequester="filterRequester" v-bind:filterController="filterController" :filterType="filterType"/>
                </b-tab>
                <!--<b-tab :title="'Revisão Final Creation (' + this.creations.underReview.length + ')'">
                  <creation-list filter="5" v-bind:creations="this.creations.underReview" v-bind:filterRequester="filterRequester" v-bind:filterController="filterController" :filterType="filterType"/>
                </b-tab>-->
                <b-tab :title="'Revisão Sleekers (' + this.unapprovedSleekers.length + ')'">
                  <sleeker-list filter="6" v-bind:sleekers="this.unapprovedSleekers"/>
                </b-tab>
                <!--<b-tab :title="'Concluído (' + this.creations.finished.length + ')'" active>
                  <creation-list filter="6" v-bind:creations="this.creations.finished" v-bind:filterRequester="filterRequester"/>
                </b-tab>-->
                </b-col>
            </b-row>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-col>
  
</template>

<script>
import service from "../service";
import Spinner from "./Spinner";
import CreationList from "./CreationList";
import SleekerList from "./SleekerList";
import Multiselect from "vue-multiselect";

export default {
  name: 'CreationManagement',
  data: () => {
    return {
      loadingData: true,
      filterRequester: 0,
      selectedCategories: [],
      categoriesList: [],
      search: "",
      admins: [],
      filterController: 0,
      unapprovedSleekers: [],
      requestSearch: "",
      filterType: 0,
      servers: []
    };
  },
  computed: {
    adminOptions: function ()  {
      if (!this.admins) {
        return [];
      } else {
        let result = [{value: 0, text: "Todos os responsáveis"}];
        for (let key in this.admins) {
          result.push({value: this.admins[key].id, text: this.admins[key].email});
        }
        return result;
      }
    }
  },
  methods: {
    addTag: function(newTag) {
      const tag = {
        name: newTag
      };
      this.categoriesList.push(tag);
      this.selectedCategories.push(tag);
    },
    add: function () {
      this.$router.push("/admin/creation/add");
    },
    getCreations: function() {
      this.loadingData = true;
      console.log(this.selectedCategories);
      service.getCreations(this.search, this.requestSearch, this.selectedCategories).then(response => {
        this.loadingData = false;
        this.creations = response.creations;
        this.unapprovedSleekers = response.unapprovedSleekers;
        this.info = response.info;
        
        if (response.creations.length == 0) {
          this.nothingAvailable = true;
        }
      }).catch(error => {
        alert(JSON.stringify(error));
        alert(error.message);
      });
    },
    goToProductivity: function () {
      this.$router.push("/admin/creation/productivity");
    },
    goToSources: function () {
      this.$router.push("/admin/creation/sources");
    }
  },
  created() {
    this.getCreations();
    service.getServers().then(result => {
      this.servers = result.servers;
    });
    service.getAllCategories().then(
      response => {
        this.categoriesList = response;
      },
      () => {
        this.showError = true;
      }
    );

    service.getAdmins().then(
      response => {
        this.admins = response.admins;
      },
      () => {
        this.showError = true;
      }
    );
  },
  components: { Spinner, CreationList, SleekerList, Multiselect }
}
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
</style>